/* eslint-disable @typescript-eslint/no-namespace,no-inner-declarations */
// tslint:disable:no-namespace object-literal-sort-keys
export const Core = {
    Vocab(term) {
        return 'http://www.w3.org/ns/hydra/core#' + (term || '');
    },
};
export const JsonLd = {
    Graph: '@graph',
    Context: '@context',
    Id: '@id',
    Value: '@value',
    Type: '@type',
    Language: '@language',
};
export const MediaTypes = {
    jsonLd: 'application/ld+json',
    ntriples: 'application/n-triples',
    nquads: 'application/n-quads',
};
export const Headers = {
    Link: 'Link',
    Location: 'Location',
    ContentType: 'Content-Type',
};
//# sourceMappingURL=Constants.js.map